export class SchedulerTaskPrint {
  constructor(
    public printHash?: string,
    public printReference?: string,
    public printProjectNumber?: string,
    public materialHash?: string,
    public materialFileName?: string,
    public manufacturingOrderHash?: string,
    public manufacturingOrderCode?: string,
    public manufacturingOrderCustomer?: string,
    public manufacturingOrderReference?: string,
    public manufacturingOrderProject?: string,
    public manufacturingOrderMpReady?: string,
    public manufacturingOrderHasMaterialReady?: boolean,
    public manufacturingOrderHasMaterialInStock?: boolean
  ) { }

  get materialPrint() {
    return `${this.materialFileName} ${this.printReference}`;
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/scheduler-task-print.ts